import React from 'react';
import { observer } from 'mobx-react';

//import NavBar from '../Components/Navbar/Main';
//import Menu from '../Components/Navbar/Menu';

const MainLayout = observer((props) => {
  
    return (
        <>
  


  
  <div className="layout-container">

    {/* 
    <nav className="layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme" id="layout-navbar">
      <NavBar {...props} />
    </nav>
    */}

    
    <div className="layout-page mt-0">

      
      <div className="content-wrapper">

        {/* 
        <aside id="layout-menu" className="layout-menu-horizontal menu-horizontal  menu bg-menu-theme flex-grow-0">
          <Menu {...props} />
        </aside>
        */}

        <div className="container-xxl flex-grow-1 container-p-y">
        {props.children}
        </div>

        <footer className="content-footer footer bg-footer-theme">
          
        </footer>


        <div className="content-backdrop fade"></div>
      </div>

    </div>

  </div>

  <div className="layout-overlay layout-menu-toggle"></div>

  <div className="drag-target"></div>

        </>
      
      
    );
});

export default MainLayout;